import * as Localia from '../constantes/Localia.js';
import * as TipoEquipo from '../constantes/TipoEquipo.js';
import * as TipoRival from '../constantes/TipoRival.js';
import { ListaPartidos } from '../constantes/Filtros.js';

export const TiposRival = [
  { id: TipoRival.CLUB, descripcion: 'Club' },
  { id: TipoRival.EQUIPO, descripcion: 'Equipo' },
  { id: TipoRival.SELECCION, descripcion: 'Selección' },
];

export const ArmarRival = (
  tipo,
  totales,
  objeto,
  agrupacionTorneo,
  categoria,
  tipoInternacional
) => {
  return {
    tipo: tipo,
    totales: totales,
    objeto: objeto,
    agrupacionTorneo: agrupacionTorneo,
    categoria: categoria,
    tipoInternacional: tipoInternacional,
  };
};

export const RivalVacio = () => ArmarRival(null, null, null, null, null, null);

export const EncontrarRival = (idTipo) => {
  return TiposRival.find((item) => item.id === idTipo);
};

export const TipoRivalInicial = (tipoHistorial) => {
  switch (tipoHistorial) {
    case TipoEquipo.CLUB:
      return EncontrarRival(TipoRival.CLUB);
    case TipoEquipo.SELECCION:
      return EncontrarRival(TipoRival.SELECCION);
    default:
      return null;
  }
};

export const GetCondicion = (partido) =>
  partido.neutral ? Localia.NEUTRAL : partido.localia || '-';

export const getFiltroPartidos = (tipoHistorial, tipoRival) => {
  const filtros = [];
  switch (tipoHistorial) {
    case TipoEquipo.CLUB:
      break;
    case TipoEquipo.SELECCION:
      if (tipoRival === TipoRival.SELECCION) {
        filtros.push(
          { codigo: ListaPartidos.TOTALES, descripcion: 'Totales' },
          { codigo: ListaPartidos.OFICIALES, descripcion: 'Oficiales' },
          { codigo: ListaPartidos.NO_OFICIALES, descripcion: 'Amistosos' }
        );
      }
      break;
    default:
  }
  return filtros;
};
